import FontAwesomeIconContainer from '../../Componant/Icons/FontAwesomeIcon/FontAwesomeIcon'

const FontAwesomeIcon = () => {
  return (
    <div className='page-body'>
      <FontAwesomeIconContainer />
    </div>
  )
}

export default FontAwesomeIcon